import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
//? English Version
import retractLockInstruction1 from "../../assets/img/tutorialimages/retractLockGuide1.png";
//? Japanese Version
import retractLockInstruction1Jap from "../../assets/img/tutorialimages/retractLockGuide1_Jap.png";

class RetractLockGuide extends Component {
  componentWillMount() {
    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={retractLockInstruction1}
            alt="retractLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={retractLockInstruction1Jap}
            alt="retractLockInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={retractLockInstruction1}
            alt="retractLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default RetractLockGuide;
